import { useCallback } from "react";
import useFetch from "hooks/useFetch";
import { getFetchOptions } from "utils/fetch";

/**
 * Fetches the durably stored AI-generated search tags for an uploaded content package.
 *
 * onTags is invoked only with a non-empty tags string; a 404 / error / empty result means "no tags
 * were generated" and must leave the existing Keywords untouched.
 */
export const useSearchTagFetch = () => {
	const { execute } = useFetch();

	const fetchSearchTags = useCallback((storedName, onTags) => {
		if (!storedName) {
			return;
		}
		execute(`/api/v3/Upload/Zip/SearchTags?storedName=${encodeURIComponent(storedName)}`, getFetchOptions({ method: "GET" }), (data, error) => {
			const tags = !error ? (data?.searchTags ?? data?.SearchTags ?? "") : "";
			if (tags) {
				onTags(tags);
			}
		});
	}, [execute]);

	return { fetchSearchTags };
};
